import { render, staticRenderFns } from "./DataTableRow.vue?vue&type=template&id=41920189&"
import script from "./DataTableRow.vue?vue&type=script&lang=ts&"
export * from "./DataTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports